











































































































































































































































































































































































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {Collapse, DatePickerWings, SelectWings, SpoilerWings, ToggleWings, InputWings} from "wings-ui-components";
import {CollapseTransition} from "vue2-transitions";
import {cloneDeep, isEqual} from "lodash";
import {ServiceProviderItem, ServiceProviderItemImpl} from "@/store/settings/service_providers/types";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {PartnerItem} from "@/store/settings/partners/types";
import { TransportItem } from '@/store/transport/types';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
  SelectWings, DatePickerWings,
  ToggleWings, Collapse, SpoilerWings,
  CollapseTransition, InputWings
}})
export default class ServiceProvider extends Vue {

  @Ref('validator') validator: any;

  @Action("getTransports") actionGetTransports: any;
  @Action("getTransportProtocols") actionGetTransportProtocols: any;
  @Action("getProtocolParameters") actionGetProtocolParameters: any;
  @Action("getServiceProviderItem") actionGetItem: any;
  @Action("saveServiceProvider") actionSave: any;
  @Action("deleteServiceProvider") actionDelete: any;
  @Action("actionLog") actionLog: any;

  @Getter("transports") transportsList!: TransportItem[];

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {};

  private smsTransportProtocols:any = []
  private smsParameters:any = []
  private callTransportProtocols:any = []
  private callParameters:any = []
  private emailTransportProtocols:any = []
  private emailParameters:any = []
  private viberTransportProtocols:any = []
  private viberParameters:any = []
  private whatsappTransportProtocols:any = []
  private whatsappParameters:any = []
  private customTransportProtocols:any = []
  private customParameters:any = [];
  private mailNotifyTransportProtocols:any = [{ id: 13, name: "Mail Notify" }];
  private mailNotifyParameters:any = [];

  defaultItem(): ServiceProviderItem {
    return new ServiceProviderItemImpl();
  }

  get transportNames(): string[] {
    return this.transportsList.map((ti: TransportItem) => ti.name);
  }

  created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Service provider"
      }
      this.actionGetItem(this.$route.params.id).then((data: PartnerItem) => {
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.logObject.object_name = this.item.name;
        this.actionLog(this.logObject);
      });
    }
    this.actionGetTransports();
    this.getParamsByTransport(1, "smsTransportProtocols", "smsParameters")
    this.getParamsByTransport(2, "callTransportProtocols", "callParameters")
    this.getParamsByTransport(3, "emailTransportProtocols", "emailParameters")
    this.getParamsByTransport(6, "viberTransportProtocols", "viberParameters")
    this.getParamsByTransport(7, "whatsappTransportProtocols", "whatsappParameters")
    this.getParamsByTransport(8, "customTransportProtocols", "customParameters")
    this.getParamsByTransport(9, "mailNotifyTransportProtocols", "mailNotifyParameters")
    this.emailParameters.map((ep:any) => {
      switch (ep.name) {
        case 'ENABLE_SSL':
        case 'ENABLE_START_TLS':
        case 'CONNECT_ON_STARTUP':
          ep.value = "false"
          break
        case 'PORT':
          ep.value = "25"
          break
      }
    })
  }

  async getParamsByTransport(transport_id:number, protocol_field_name:string, param_field_name:string) {
    let _self:any = this;
    let response = await this.actionGetTransportProtocols(transport_id)
    let data = await response.data
    _self[protocol_field_name] = data.protocols
    for (const tp of _self[protocol_field_name]) {
      let resp = await this.actionGetProtocolParameters({transport: transport_id, protocol: tp.id})
      let protocolObject = await resp.data;
      _self[param_field_name].push.apply(_self[param_field_name], protocolObject.parameters);
    }
  }

  getValidationRuleByParameter(parameterName: string, transportName: string) {
    return {
      required: parameterName==='NAME' || parameterName==='SERVER' || parameterName==='PORT'|| parameterName==='DEFAULT_FROM',
      max: parameterName==='PORT' ? {length: 5} : false,
      max_value: parameterName==='PORT' ? {max: 65535} : false,
      min_value: parameterName==='PORT' ? {min: 0} : false,
      required_if: parameterName==='PASSWORD' ? {target: `${transportName}_USERNAME`} : (parameterName==='USERNAME' ? {target: `${transportName}_PASSWORD`} : false),
      non_cyrillic: true,
      non_space: parameterName==='NAME' || parameterName==='USERNAME' || parameterName==='PASSWORD',
      alpha_num_dash_dot:  parameterName==='NAME' || parameterName==='SERVER',
      email: parameterName==='DEFAULT_FROM',
    }
  }

  back(): void {
    this.$router.push('/settings/service_providers/');
  }

  async onSaveItem(): Promise<void> {
    if (this.item.transport_ids?.length === 0) {
      setTimeout(() => {
        notifyError(null, ['Нужно указать хотя бы 1 активный транспорт']) // TODO: i18n
      }, 100);
      return
    }
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Service provider",
          object_name : this.item.name,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error()
    }
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Service provider",
          object_name : this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  getParameterValue(transport_id: number, param_id:number): any {
    return this.item.parameters?.filter(param => param.protocol_parameter_id === param_id)
      .map(param => {
        if (param.name==='WCS_GATEWAY' && !param.value) {
          let transportName = this.transportsList.find((tr:any) => tr.id === transport_id)?.name?.toLowerCase()
          param.value = `re-${transportName}$${param.protocol_name?.toLowerCase()}`
        }
        return param.value;
      })[0]
  }

  setParameterValue(protocol_id: number, param_id: number, value: string) {
    if (this.item.parameters?.find(param => param.protocol_parameter_id === param_id)) {
      this.item.parameters?.filter(param => param.protocol_parameter_id === param_id)
        .map(param => param.value = (value && value !=="" ? value.trim() : undefined))
    } else {
      this.item.parameters?.push({
        protocol_parameter_id: param_id,
        protocol_id: protocol_id,
        value: (value && value !=="" ? value.trim() : undefined)
      })
    }
    this.$emit('input', value?.trim())
  }

  getBooleanParameterValue(transport_id: number, param_id:number): boolean {
    return this.getParameterValue(transport_id, param_id) ? JSON.parse(this.getParameterValue(transport_id, param_id)) : false
  }

  setBooleanParameterValue(transport_id: number, param_id: number, value: boolean) {
    console.log(value)
    this.item.parameters?.filter(param => param.protocol_parameter_id === param_id)
      .map(param => param.value = (value === true).toString())
    this.$emit('change', value && value === true)
  }

  getTransportValue(id: number): boolean {
    return this.item.transport_ids?.some(pti => pti === id) || false
  }

  setTransportValue(value: boolean, id: number, protocolField:string) {
    if (value) {
      this.item.transport_ids?.push(id)
    } else {
      this.item.transport_ids = this.item.transport_ids?.filter(ti => ti !== id)
      //@ts-ignore
      this.item[protocolField] = undefined
    }
  }

  @Watch('item.sms_protocol_id', { immediate: true })
  onChangeSmsProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.smsParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.call_protocol_id', { immediate: true })
  onChangeCallProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.callParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.email_protocol_id', { immediate: true })
  onChangeEmailProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.emailParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.viber_protocol_id', { immediate: true })
  onChangeViberProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.viberParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.whatsapp_protocol_id', { immediate: true })
  onChangeWhatsappProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.whatsappParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.custom_protocol_id', { immediate: true })
  onChangeCustomProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.customParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  @Watch('item.mn_protocol_id', { immediate: true })
  onChangeMailNotifyProtocolId(val:number, oldVal?: number){
    if (val) {
      if (oldVal) this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
      this.item.parameters?.push.apply(this.item.parameters,this.mailNotifyParameters.filter((ep:any) => ep.protocol_id === val))
    } else {
      this.item.parameters = this.item.parameters?.filter(prm => prm.protocol_id !== oldVal)
    }
  }

  get smsTransportValue(): boolean {
    return this.getTransportValue(1)
  }

  set smsTransportValue(value: boolean) {
    this.setTransportValue(value, 1, 'sms_protocol_id')
  }

  get callTransportValue(): boolean {
    return this.getTransportValue(2)
  }

  set callTransportValue(value: boolean) {
    this.setTransportValue(value, 2, 'call_protocol_id')
  }

  get emailTransportValue(): boolean {
    return this.getTransportValue(3)
  }

  set emailTransportValue(value: boolean) {
    this.setTransportValue(value, 3, 'email_protocol_id')
  }

  get viberTransportValue(): boolean {
    return this.getTransportValue(6)
  }

  set viberTransportValue(value: boolean) {
    this.setTransportValue(value, 6, 'viber_protocol_id')
  }

  get whatsappTransportValue(): boolean {
    return this.getTransportValue(7)
  }

  set whatsappTransportValue(value: boolean) {
    this.setTransportValue(value, 7, 'whatsapp_protocol_id')
  }

  get mailNotifyTransportValue(): boolean {
    return this.getTransportValue(9);
  }

  set mailNotifyTransportValue(value: boolean) {
    if(value) this.item.mn_protocol_id = 13;
    else this.item.mn_protocol_id = undefined;
    this.setTransportValue(value, 9, 'mn_protocol_id')
  }

  get customTransportValue(): boolean {
    return this.getTransportValue(8)
  }

  set customTransportValue(value: boolean) {
    this.setTransportValue(value, 8, 'custom_protocol_id')
  }
}
